import { createSlice } from "@reduxjs/toolkit";
import { updateDeliveryStatus } from "../../apis/dispense/updateDeliveryStatus";
import { extractNestedApiErrorMessage } from "../../../utils/helper/apiErrorMessage";

const initialState = {
    loading: false,
    data: null,
    error: null,
    userFacingErrorMessage: null,
}

const pickUserFacingMessage = (payload) => {
    if (payload && typeof payload === 'object' && 'userFacingMessage' in payload) {
        const m = payload.userFacingMessage;
        return typeof m === 'string' && m.trim() ? m.trim() : null;
    }
    if (payload?.data) {
        return extractNestedApiErrorMessage(payload.data) || null;
    }
    return null;
}

const updateDeliveryStatusSlice = createSlice({
    name: 'updateDeliveryStatus',
    initialState,
    reducers: {
        clearUpdateDeliveryUserMessage(state) {
            state.userFacingErrorMessage = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(updateDeliveryStatus.pending.type, (state) => {
            return {
                ...state,
                loading: true,
                data: null,
                error: null,
                userFacingErrorMessage: null,
            }
        })

        builder.addCase(updateDeliveryStatus.fulfilled.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
                userFacingErrorMessage: null,
            }
        })

        builder.addCase(updateDeliveryStatus.rejected.type, (state, action) => {
            const payload = action.payload;
            const userFacing = pickUserFacingMessage(payload);
            const innerError = payload && typeof payload === 'object' && 'inner' in payload
                ? payload.inner
                : payload;
            return {
                ...state,
                loading: false,
                data: null,
                error: innerError ?? null,
                userFacingErrorMessage: userFacing,
            }
        })
    }

})

export const { clearUpdateDeliveryUserMessage } = updateDeliveryStatusSlice.actions;
export default updateDeliveryStatusSlice.reducer;
